// extracted by mini-css-extract-plugin
export default {"payment":"CheckoutPayment_payment__6w9i6"};